export function useSocials() {

  function getIcon(name: string) {
    if (name === 'twitter') return 'ri:twitter-x-line'
    return `ri:${name}-line`
  }

  function getBgColor(name: string) {
    switch (name) {
      case 'twitter':
        return 'bg-twitter ';
      case 'facebook':
        return 'bg-facebook  ';
      case 'instagram':
        return 'bg-instagram  ';
      case 'linkedin':
        return 'bg-linkedin ';
      case 'youtube':
        return 'bg-youtube ';
      case 'whatsapp':
        return 'bg-whatsapp ';
      case 'pinterest':
        return 'bg-pinterest ';
      case 'tiktok':
        return 'bg-tiktok ';
      default:
        return 'bg-gray-500 ';
    }
  }

  function getTextColor(name: string) {
    switch (name) {
      case 'twitter':
        return 'text-white hover:text-twitter';
      case 'facebook':
        return 'text-white hover:text-facebook';
      case 'instagram':
        return 'text-white hover:text-instagram';
      case 'linkedin':
        return 'text-white hover:text-linkedin';
      case 'youtube':
        return 'text-white hover:text-youtube';
      case 'whatsapp':
        return 'text-white hover:text-whatsapp';
      case 'pinterest':
        return 'text-white hover:text-pinterest';
      case 'tiktok':
        return 'text-white hover:text-tiktok';
      default:
        return 'text-white hover:text-gray-500';
    }
  }

  function getButtonColor(name: string) {
    const color = getBgColor(name)
    const text = getTextColor(name)
    return `${color} ${text} hover:bg-white`
  }



  return {
    getIcon,
    getBgColor,
    getTextColor,
    getButtonColor
  }
}
